import { render, staticRenderFns } from "./room-block.vue?vue&type=template&id=28a3aeb5&scoped=true&"
import script from "./room-block.js?vue&type=script&lang=js&"
export * from "./room-block.js?vue&type=script&lang=js&"
import style0 from "./room-block.css?vue&type=style&index=0&id=28a3aeb5&scoped=true&lang=css&"
import style1 from "./room-block-vuetify.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3aeb5",
  null
  
)

export default component.exports